<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_ii"></a><span class="small">NEW YORK UNIVERSITY PRESS</span><br/>New York and London</p>
<p class="copyright">© 1999 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>Andrews, Marcellus, 1956–<br/>The political economy of hope and fear : capitalism and the<br/>Black condition in America / Marcellus Andrews.<br/>p.   cm.<br/>Includes bibliographical references (p. ) and index.<br/>ISBN 0-8147-0679-7 (acid-free paper)<br/>1. Afro-Americans—Economic conditions.    2. United<br/>States—Economic conditions—1945–   3. Capitalism—United<br/>States—History—20th century.   4. United States—Economic<br/>policy.<br/>I. Title.<br/>E185.8. A77    1999<br/>330.973’09—dc21                98-58107<br/>                                                     CIP</p>
<p class="copyright">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="copyright">Manufactured in the United States of America</p>
<p class="copyright">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_copy.vue?f808b5f8